import React from "react";
import Icon, { IconProps } from "./Icon";
import { vars } from "@puzzle/theme";

export default function Dots({ className, size = 10, viewBox = "0 0 10 10", ...props }: IconProps) {
  return (
    <Icon className={className} viewBox={viewBox} size={size} {...props}>
      <circle cx="1" cy="5" r="1" fill={vars.colors["text-neutral-base"]}></circle>
      <circle cx="5" cy="5" r="1" fill={vars.colors["text-neutral-base"]}></circle>
      <circle cx="9" cy="5" r="1" fill={vars.colors["text-neutral-base"]}></circle>
    </Icon>
  );
}
